import { Flex, Button, Text } from "@chakra-ui/react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useAuth } from "../../providers/AuthProvider/AuthProvider";
import { useTranslation } from "react-i18next";
import MobileMenu from "../MobileMenu/MobileMenu";
import Logo from "../../components/Logo/Logo";

const Menu = ({ variant = "default" }) => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { t } = useTranslation("default");
    const { user, logout, isSuperAdmin } = useAuth();

    const ROUTES = [
        {
            label: t('menu.nav.main'),
            route: '/'
        },
        {
            label: t('menu.nav.setup'),
            route: '/setup'
        },
        {
            label: t('menu.nav.categories'),
            route: '/categories',
            protected: isSuperAdmin()
        },
        {
            label: t('menu.nav.users'),
            route: '/users',
            protected: isSuperAdmin()
        },
    ];

    const isActive = (route) => route === '/'
        ? pathname === '/' || pathname.startsWith('/events')
        : pathname.startsWith(route);

    const handleAction = () => {
        if (user) {
            logout();
        } else {
            navigate('/login');
        }
    }

    return (
        <Flex as="header" bg={'surface.card'} w={'100%'} justifyContent={'center'} alignItems={'center'}
            h={{ base: '64px', md: '72px' }} borderBottom="1px solid" borderColor="surface.border"
            position="sticky" top="0" zIndex="999" px={{ base: '16px', md: '24px', '2xl': 0 }}>
            <Flex w="100%" maxW="7xl" justifyContent={'space-between'} alignItems={'center'} gap={{ base: '16px', lg: '48px' }}>
                <Flex alignItems="center" gap={{ base: '10px', md: '12px' }} flexShrink={0}>
                    <a href="https://evenado.com" aria-label="Evenado">
                        <Logo />
                    </a>
                    <Text as="span" fontSize="12px" fontWeight={700} color="brand.600" bg="brand.100"
                        px="10px" py="4px" borderRadius="full" whiteSpace="nowrap">
                        {t('menu.panel', 'Panel organizatora')}
                    </Text>
                </Flex>

                <Flex flex="1" justifyContent="space-between" alignItems="center" display={{ base: 'none', lg: 'flex' }}>
                    <Flex as="nav" gap="4px">
                        {user && ROUTES.filter(r => r.protected !== false).map(r => (
                            <Link key={r.route} to={r.route}>
                                <Text as="span" display="inline-flex" alignItems="center" h="40px" px="14px" borderRadius="10px"
                                    fontSize="15px" fontWeight={600}
                                    color={isActive(r.route) ? 'brand.600' : 'ink.600'}
                                    bg={isActive(r.route) ? 'brand.100' : 'transparent'}
                                    _hover={{ bg: isActive(r.route) ? 'brand.100' : 'surface.page', color: 'ink.900' }}>
                                    {r.label}
                                </Text>
                            </Link>
                        ))}
                    </Flex>
                    {variant === "default" ? (
                        <Button
                            variant="outline"
                            bg="white"
                            h="44px"
                            px="22px"
                            color="ink.900"
                            borderColor="surface.control"
                            borderRadius="full"
                            _hover={{ bg: 'surface.page', transform: 'none', boxShadow: 'none' }}
                            onClick={handleAction}
                        >
                            {t(user ? 'menu.logout' : 'menu.login')}
                        </Button>
                    ) : (
                        <Button
                            bg="brand.500"
                            color="white"
                            h="44px"
                            px="22px"
                            borderRadius="full"
                            gap="8px"
                            onClick={() => { navigate("/") }}
                        >
                            {t('check.events')}
                        </Button>
                    )}
                </Flex>
                <MobileMenu routes={ROUTES} />
            </Flex>
        </Flex>
    )
}

export default Menu;
